@if (menuConfig) {
  <div>
    <app-entity-group-header
      [displayHeader]="includeHeader"
      [mode]="dataSourceMode"
      [editMode]="isEdit()"
      [code]="routeBase"
      [entityId]="id"
      [entityGroupId]="entityGroupId"
      [data]="data"
      [menuConfig]="menuConfig"
      (loadingEmitter)="onLoadingEmitter($event)"
      [refreshSubject]="refreshSubject"
      [groupConfig]="groupConfig"
      (refreshSignalled)="refreshPage()"
      (headerInitialized)="headerInitized($event)">
    </app-entity-group-header>
    @if (mode === 'report' && route.snapshot.queryParams['show']) {
      <span>
        <button mat-raised-button color="accent" (click)="goBackToReportParamsForm()">
          <b>Change params</b>
        </button>
        <button mat-icon-button (click)="refreshReport()">
          <mat-icon>refresh</mat-icon>
        </button>
      </span>
    }
    <ng-container> </ng-container>
    @if (headerValue || !includeHeader) {
      @if (!contentLoading) {
        <div class="main-container">
          @if (menuConfig) {
            <div class="horizontal-padding">
              @if (entityGroupId) {
                <div>
                  <a (click)="navigateBackToList()">
                    <button mat-icon-button>
                      <mat-icon>keyboard_arrow_left</mat-icon>
                    </button>
                  </a>
                  <h3>{{ getTitleOfNestedEntity() }}</h3>
                </div>
              }
              @if (formGroup) {
                <form [formGroup]="formGroup">
                  @if (!isTableView) {
                    @if (isWageringProfileOverall()) {
                      <app-wagering-profile-overall
                        [data]="data"
                        [formGroup]="formGroup"
                        [columnConfig]="availableColumns?.[0]"
                        [formConfig]="groupConfig"
                        [entityId]="id"
                        [createMode]="mode === EntityDetailsMode.ADD"
                        (loadingEmitter)="onLoadingEmitter($event)">
                      </app-wagering-profile-overall>
                    } @else {
                      <div #grid class="grid" data-isotope='{ "itemSelector": ".grid-item", "layoutMode": "packery" }'>
                        @for (column of availableColumns; track column; let i = $index) {
                          <div class="grid-item" [style.width]="column.fxFlex + '%'">
                            <app-entity-group-subset
                              [data]="data"
                              (loadingEmitter)="onLoadingEmitter($event)"
                              (editingEmitter)="layoutEvent()"
                              [entityId]="id"
                              [config]="column"
                              [formGroup]="formGroup"
                              [edit]="isEdit()"
                              [formConfig]="groupConfig"
                              [column]="i"
                              [row]="0"
                              [mode]="mode"
                              [refreshSubject]="refreshSubject">
                            </app-entity-group-subset>
                          </div>
                        }
                      </div>
                    }
                  }
                  @if (mode === EntityDetailsMode.ADD) {
                    <button
                      type="submit"
                      data-id="createNew"
                      mat-raised-button
                      class="submit-button"
                      (click)="submitFull()">
                      Create new
                    </button>
                  }
                </form>
              }
              @if (isTableView) {
                <div class="container-fluid">
                  <app-maintain-table
                    [entityCode]="entityCode"
                    [context]="headerValue"
                    [nested]="true"></app-maintain-table>
                </div>
              }
            </div>
          }
          @if (mode === 'report' && !route.snapshot.queryParams['show']) {
            <button mat-raised-button color="accent" (click)="submitNormalForm()">
              <b>Go</b>
            </button>
          }
        </div>
      }
      @if (contentLoading) {
        <div class="spinner">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      }
    }
  </div>
}
